export class ApplePayPaymentMethodUpdate implements ApplePayJSV14.ApplePayPaymentMethodUpdate {
	newTotal: ApplePayJS.ApplePayLineItem;
	newRecurringPaymentRequest?: ApplePayJSV14.ApplePayRecurringPaymentRequest;
	errors?: ApplePayError[];
	newLineItems?: ApplePayJS.ApplePayLineItem[];
}
